import { gql } from '@apollo/client';

import { EModItemResolutionState } from '@/client/legacy-shared-modules/moderation-item/moderationType';

import { useModeration_PostFragment } from './graphql-types/useModeration_PostFragment';

const POST_FRAGMENT = gql`
  fragment useModeration_PostFragment on PostV2 {
    _id
    moderationItem {
      _id
      resolutionState
    }
    currentUserCanResolveModeratedState
    currentUserIsPostAuthor
    ... on AnswerV2 {
      _id
      questionPost {
        _id
        moderationItem {
          _id
          resolutionState
        }
        currentUserCanResolveModeratedState
        currentUserIsPostAuthor
      }
    }
  }
`;

export const useModeration = (options: {
  post: useModeration_PostFragment;
  isAnswerHeader: boolean;
}): {
  shouldHidePost: boolean;
  shouldShowHeader: boolean;
} => {
  const { post, isAnswerHeader } = options;
  if (post.__typename === 'AnswerV2' && !isAnswerHeader) {
    if (!post.questionPost) {
      return {
        shouldHidePost: false,
        shouldShowHeader: false,
      };
    } else if (
      !post.questionPost.moderationItem?._id ||
      post.questionPost.moderationItem.resolutionState ===
        EModItemResolutionState.APPROVED
    ) {
      return {
        shouldHidePost: false,
        shouldShowHeader: false,
      };
    }
    return post.questionPost.moderationItem.resolutionState ===
      EModItemResolutionState.PENDING
      ? post.questionPost.currentUserCanResolveModeratedState ||
        post.questionPost.currentUserIsPostAuthor
        ? {
            shouldHidePost: false,
            shouldShowHeader: true,
          }
        : { shouldHidePost: true, shouldShowHeader: false }
      : post.questionPost.currentUserCanResolveModeratedState
      ? { shouldHidePost: false, shouldShowHeader: true }
      : { shouldHidePost: true, shouldShowHeader: false };
  }
  if (
    !post.moderationItem?._id ||
    post.moderationItem.resolutionState === EModItemResolutionState.APPROVED
  ) {
    return {
      shouldHidePost: false,
      shouldShowHeader: false,
    };
  }
  return post.moderationItem.resolutionState === EModItemResolutionState.PENDING
    ? post.currentUserCanResolveModeratedState || post.currentUserIsPostAuthor
      ? {
          shouldHidePost: false,
          shouldShowHeader: true,
        }
      : { shouldHidePost: true, shouldShowHeader: false }
    : post.currentUserCanResolveModeratedState
    ? { shouldHidePost: false, shouldShowHeader: true }
    : { shouldHidePost: true, shouldShowHeader: false };
};
useModeration.postFragment = POST_FRAGMENT;
